import { ICopyDeck } from "@/models/vimy.models";
import axios from "axios";

import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import { EventStore } from ".";

@Module
export class LocaleModule extends VuexModule {
    private _data: ICopyDeck = {};
    private _isFetching: boolean = false;
    private _didFetchFailed?: boolean = undefined;

    get didFetchFailed(): boolean | undefined {
        return this._didFetchFailed;
    }

    get isFetching() : boolean {
        return this._isFetching;
    }

    get data(): ICopyDeck {
        return this._data;
    }

    @Mutation
    private setLocales(data: ICopyDeck) : void {
        this._data = data;
        this._didFetchFailed = false;

        EventStore.triggerCopyDeck(data);
    }

    @Mutation
    private setFetching(value: boolean) {
        this._isFetching = value;
    }

    @Mutation
    private handleError() {
        this._didFetchFailed = true;
    }

    @Action
    fetchLocales(): void {
        this.setFetching(true);

        const endpoint: string = '/endpoints/memorial/copydeck';
        axios.get(endpoint, {})
            .then(async (response) => {
                if (response.status != 200) {
                    this.handleError();
                    return;
                }

                this.setLocales(response.data);
            })
            .catch(() => {
                this.handleError();
            })
            .finally(() => {
                this.setFetching(false);
            });
    }
}
